<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Expense Drivers</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="vertical-flex">
                  <p class="mt-3">
                    Expense drivers are your key wage costs. For each group (owner, salaried, and casual) enter total weekly hours (e.g., 2 salaried staff at 40 hours = 80 hours) and the average hourly wage per group.
                  </p>
                  <img src="@/assets/images/expense-drivers.png" alt="Example Expense Drivers" class="img-fluid form-center" />
                  <p class="mt-4">
                    To reflect seasonal changes, adjust the monthly seasonality percentage to increase or decrease anticipated casual staff hours. This helps Sinchii better project your cash flow. You can update these settings anytime.
                  </p>
                  <img src="@/assets/images/seasonality-expense.png" alt="Example Expense Seasonality" class="img-fluid form-center" />
                  <p class="mt-5">
                    Fill in your expense drivers set to get started.
                  </p>
                  <p class="mt-3">
                    For more information about expense drivers and how to use Sinchii, click <a href="https://sinchii.com.au/resources/" target="_blank">here</a>.
                  </p>
                </div>
              </div> 
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4">
      <div class="row justify-content-center pt-5">
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="close">Let's Begin</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icon from "../Icon.vue";

export default {
  components: {
    icon
  },
  methods: {
    close() {
      this.$emit("onClose");
    }
  }
};

</script>
